import { DimCodeName } from "api";
import { ContractOrderRequestSelectedOptions } from "services/ContractService";
import { services } from "contexts/ServiceContext";

export const mapDimCodeNameToSelectOption = (
  value: DimCodeName
): SelectOption => ({
  label: value.Name ?? "",
  value: value.Code ?? "",
});

export const getContractOrderRequestQueryOptions = (
  docEntry: number | undefined,
  selectedOptions: ContractOrderRequestSelectedOptions
) => ({
  queryKey: [
    "get-contract-order-request-select-options",
    { docEntry },
    { ...selectedOptions },
  ],
  queryFn: () => {
    return docEntry
      ? services.contractService.getContractOrderRequestSelectOptions(
          docEntry,
          selectedOptions
        )
      : Promise.reject();
  },
});
